module.exports = "/images/speaker.svg?412e7434e6bb15bcfef8622b25b7b6e9";